import React from 'react'

const ViewStore = () => {
  return (
    <div className='mx-auto p-4'>
      <h4 className='font-semibold my-4'>Imaging <span className='text-[#0E6F1E]'>> StoreManagement > View</span></h4>

      <div className="bg-white p-4 rounded-lg">
        <h4 className='font-bold text-[#ff810d]'>Pending</h4>
        <div>
          
        </div>
      </div>
    </div>
  )
}

export default ViewStore
